import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { VmeCommonModule } from '../../vme-common.module';
import { VMEComponentsModule } from '../../vme-components.module';
import { VmeDirectivesModule } from '../../vme-directives.module';
import { VmePipesModule } from '../../vme-pipes.module';
import { OrderDumpComponent } from './order-dump.component';

const routes: Routes = [{ path: '', component: OrderDumpComponent, data: { title: 'Order Dump' } }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class OrderDumpRoutingModule {}

@NgModule({
  imports: [
    OrderDumpRoutingModule,
    VmeCommonModule,
    VmeDirectivesModule,
    VmePipesModule,
    VMEComponentsModule,
  ],
  declarations: [OrderDumpComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class OrderDumpModule {}
